import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { supportUser } from "../../rbac-consts";
import { default as SuperAdminUserSupportContainer } from "./superAdmin/SupportUserContainer";

const SupportUserWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={supportUser.SUPER_ADMIN}
      yes={() => (
        <SuperAdminUserSupportContainer />
      )}
    />
  );
};

export default SupportUserWrapper;